import type { FC } from 'react';
import CreativeTextForm from './CreativeTextForm';
import { Navigate, useParams } from 'react-router';
import { SuspenseBoundary } from 'components/common';
import { cabinetDatadogSources } from 'lib/datadog';
import { useCreativeTextsDetails } from '../api';
import CreativeTextsFormSkeleton from './CreativeTextsFormSkeleton';

const EditCreativeTextComponent: FC = () => {
  const { textId } = useParams();
  const { data: creativeText } = useCreativeTextsDetails({
    params: { textId },
  });

  if (!textId) return <Navigate to={'/'} />;
  return <CreativeTextForm creativeText={creativeText} />;
};

const EditCreativeText: FC = () => {
  return (
    <SuspenseBoundary
      fallback={<CreativeTextsFormSkeleton />}
      datadogSource={cabinetDatadogSources.detailsQuery('tiktok', 'creative_text')}
    >
      <EditCreativeTextComponent />
    </SuspenseBoundary>
  );
};

export default EditCreativeText;
